import React from 'react';
import BasicMenu from './tempComps/Menus';

const ProfileCard = () => {
  return (
    <div className="relative w-11/12 mx-auto bg-[#6E39CB] text-white p-2 rounded-lg">
      <div className="flex items-center">
        <img src={require('../assets/img_1.png')} alt="User profile picture" className="rounded-full w-8 h-8" />
        <div className="ml-2">
          <div className="text-[12px]">Demo user</div>
          <div className="text-[10px]">user@demo.com</div>
        </div>
        <BasicMenu />
      </div>
    </div>
  );
};

export default ProfileCard;
